/* @flow */
import React from 'react';
// $FlowIgnore
import { MdDashboard } from 'react-icons/md';

export default function DashboardIcon({
  style
}: Object): React.Element {
  return <MdDashboard style={style} />;
}
